import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import { getPropertyIcon } from 'automation-ui-formula-editor/data-sources/utils/getPropertyIcon';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { ENFORCE_FIELD_LEVEL_PERMISSIONS, SUPPORT_SELECTING_SENSITIVE_PROPERTIES } from 'automation-ui-formula-editor/constants/Gates';
import { jsx as _jsx } from "react/jsx-runtime";
const DataPanelPropertyIcon = ({
  dataProperty,
  requiredPermissionLevel
}) => {
  const isGatedToSupportSelectingSensitiveProperties = !useIsUngated(SUPPORT_SELECTING_SENSITIVE_PROPERTIES);
  const enforceFlp = useIsUngated(ENFORCE_FIELD_LEVEL_PERMISSIONS);
  const iconName = getPropertyIcon({
    dataSensitivityAllowlist: isGatedToSupportSelectingSensitiveProperties ? ['none'] : undefined,
    dataProperty,
    enforceFlp,
    requiredPermissionLevel
  });
  return iconName ? /*#__PURE__*/_jsx(UIIcon, {
    name: iconName,
    size: 'xxs',
    className: "p-right-2",
    color: EERIE
  }) : null;
};
export default DataPanelPropertyIcon;